<template>
    <Teleport to="body">
        <div
            class="fixed w-full h-full z-[1000] top-0 left-0 bg-black"
            v-if="state.isOpen"
            ref="container"
        >
            <div
                class="
                    w-[20%]
                    absolute
                    z-[10]
                    bg-[#00000080]
                    right-0
                    p-4
                    h-full
                "
                v-show="state.isPlaylistOpen"
            >
                <h3 class="text-white">Playlist</h3>
                <div class="flex flex-col gap-10 mt-4">
                    <div class="" v-for="video in state.videos" :key="video.id">
                        <div class="w-full h-full relative">
                            <img :src="video.thumbnail" :alt="video.title" />
                            <div
                                class="
                                    top-0
                                    left-0
                                    flex
                                    bg-[#00000080]
                                    text-white
                                    absolute
                                    w-full
                                    h-full
                                    items-center
                                    justify-center
                                    text-[20px]
                                "
                                v-if="state.currentVideo?.id === video.id"
                            >
                                NOW PLAYING
                            </div>
                            <div
                                class="
                                    top-0
                                    left-0
                                    flex
                                    bg-[#00000080]
                                    absolute
                                    w-full
                                    h-full
                                    items-center
                                    justify-center
                                    text-[48px] text-red-500
                                    cursor-pointer
                                "
                                @click="playVideo(video)"
                                v-else
                            >
                                <ion-icon name="play"></ion-icon>
                            </div>
                        </div>
                        <div class="text-white mt-1">
                            <div>{{ video.title }}</div>
                            <span class="text-gray-400 text-[12px]"
                                >Created at
                                {{
                                    new Date(video.created_at).toLocaleString()
                                }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex gap-4 w-full h-full">
                <div class="flex-grow w-full h-full">
                    <CustomVideoPlayer
                        :thumbnail="state.currentVideo?.thumbnail"
                        :url="state.currentVideo?.url"
                        :title="state.currentVideo?.title"
                        :start-sec="state.currentVideo?.start_sec ?? null"
                        :end-sec="state.currentVideo?.end_sec ?? null"
                        custom-fullscreen
                        is-playlist
                        @prev="handlePrev"
                        @next="handleNext"
                        @fullscreen="toggleFullscreen"
                        @ended="handleEnded"
                        :is-prev-disabled="isPrevDisabled"
                        :is-screen-auto="true"
                        :is-next-disabled="isNextDisabled"
                    >
                        <template #controls>
                            <button @click="togglePlaylist">
                                <ion-icon name="list-outline"></ion-icon>
                            </button>
                        </template>
                    </CustomVideoPlayer>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
import { computed, reactive, ref, defineProps } from "vue";
import emitter from "tiny-emitter/instance";
emitter.on("open-playlist", (data) => {
    state.isOpen = true;
    state.currentVideo = data;
    getVideos(data);
    if (container.value.requestFullscreen) {
        container.value.requestFullscreen();
    } else if (container.value.webkitRequestFullscreen) {
        container.value.webkitRequestFullscreen();
    } else if (container.value.mozRequestFullScreen) {
        container.value.mozRequestFullScreen();
    }
    document.body.classList.add("no-scroll");
});

let container = ref(null);

const state = reactive({
    isOpen: false,
    isPlaylistOpen: false,
    currentVideo: null,
    currentVideoIndex: null,
    videos: [],
});

const isPrevDisabled = computed(() => state.currentVideoIndex === 0);
const isNextDisabled = computed(
    () => state.currentVideoIndex === state.videos.length - 1
);

async function getVideos(video) {
    const teamId = video.team_id ? video.team_id : "";
    const resp = await axios.get(
        `/video/list?teamId=${teamId}&videoGroupId=${video.video_group_id}`
    );
    state.videos = resp.data;
    state.currentVideoIndex = state.videos.findIndex((v) => v.id === video.id);
}

function handlePrev() {
    state.currentVideoIndex = state.currentVideoIndex - 1;
    state.currentVideo = state.videos[state.currentVideoIndex];
}

function handleNext() {
    state.currentVideoIndex = state.currentVideoIndex + 1;
    state.currentVideo = state.videos[state.currentVideoIndex];
}

function playVideo(video) {
    state.currentVideo = video;
    state.currentVideoIndex = state.videos.findIndex((v) => v.id === video.id);
}

function togglePlaylist() {
    state.isPlaylistOpen = !state.isPlaylistOpen;
}

function handleEnded() {
    if (isNextDisabled.value) {
        return;
    }

    handleNext();
}

function toggleFullscreen() {
    state.isOpen = false;
    if (document.fullscreenElement) {
        document.exitFullscreen();
    }
    document.body.classList.remove("no-scroll");
}
</script>
